/* ============================================================
   AGC PAGES JS — páginas de contenido (FAQ / envíos / devoluciones / contacto)
   - acordeón FAQ (física Apple)
   - reveal en scroll
   - dots del slider de la isla de producto
   (La barra de menú es el componente compartido agc-nav.js)
   ============================================================ */
(function () {
  'use strict';
  var root = document.getElementById('agc-pg');
  if (!root) return;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  /* ── acordeón FAQ (un solo abierto por categoría) ── */
  $$('.agc-faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.agc-faq-item');
      if (!item) return;
      var wasOpen = item.classList.contains('open');
      var group = item.closest('.agc-faq-group') || root;
      group.querySelectorAll('.agc-faq-item.open').forEach(function (o) { if (o !== item) o.classList.remove('open'); });
      item.classList.toggle('open', !wasOpen);
    });
  });

  /* ── reveal en scroll ── */
  (function () {
    var els = $$('.agc-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { root: root, threshold: 0.14 });
    els.forEach(function (e) { io.observe(e); });
  })();

  /* ── dots del slider de la isla ── */
  (function () {
    var track = $('[data-isla-track]');
    var dotsWrap = $('[data-isla-dots]');
    if (!track || !dotsWrap) return;
    var cards = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(dotsWrap.children);
    var raf = null;
    function active() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestD = Infinity;
      cards.forEach(function (c, i) {
        var mid = c.offsetLeft + c.offsetWidth / 2;
        var d = Math.abs(mid - center);
        if (d < bestD) { bestD = d; best = i; }
      });
      dots.forEach(function (d, i) { d.classList.toggle('on', i === best); });
    }
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; active(); });
    }, { passive: true });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        if (cards[i]) cards[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });
  })();
})();
